module.exports = __webpack_public_path__ + "img/lens-150-minus-07.733c8e00.png";